import { __module as t } from "../../../_virtual/isJSON.js";
import { a as o } from "./util/assertString.js";
import { m as r } from "./util/merge.js";
!function (t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (t, o) {
    (0, u.default)(t);
    try {
      o = (0, l.default)(o, a);
      var r = [];
      o.allow_primitives && (r = [null, !1, !0]);
      var e = JSON.parse(t);
      return r.includes(e) || !!e && "object" === n(e);
    } catch (t) {}
    return !1;
  };
  var u = i(o),
    l = i(r);
  function i(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function n(t) {
    return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  var a = {
    allow_primitives: !1
  };
  t.exports = e.default, t.exports.default = e.default;
}(t, t.exports);
var e = t.exports;
export { e as i };